// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__ba99j","errorLogs":"EditorFooter_errorLogs__2bP4V"};